import React from "react";
import SideBar from "./SideBar";

const MachineLearning = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-3">
          <SideBar machineLearning = {true}/>
        </div>
        <div className="col-lg-9 padding-lg">
          <div className="heading mt-5">Machine Learning</div>
          <hr />
          <div className="row">
            <div className="col-md-7">
              <p className="mb-auto textAlign">
                {/* Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Doloremque distinctio odio nulla adipisci ea, harum natus minima
                quas nihil, quos pariatur mollitia, amet sunt. Id nostrum
                assumenda veniam inventore quae cumque. Eveniet autem ea
                reprehenderit corporis soluta dolores minima ducimus reiciendis
                dolorum facilis officia mollitia velit voluptas unde culpa
                recusandae error beatae deleniti consequatur eius totam nostrum,
                quos obcaecati! Iste veniam facere aspernatur pariatur id quasi?
                Sed corrupti sit quaerat dicta iusto molestias pariatur illo cum
                consectetur maxime laudantium dolorum sunt ad ipsam et, eum
                dolore temporibus eaque esse. Ex id accusantium inventore, qui
                itaque iure nam nulla architecto! */}
              </p>
            </div>
            <div className="col-md-5 text-center">
              <div className="card-text mb-auto research p-3">
                <img src="" alt="" />
              </div>
            </div>
          </div>
          <div className="heading mt-4">Publications</div>
          <hr />
          <div className="mb-4 textAlign">
            {/* <li>
              Das CK and Singh JK, &nbsp;
              <a href="#" className="remove-underline" target={"_blank"}>
                <font color="808000">
                  "Effect of confinement on the solid-liquid coexistence of
                  Lennard-Jones Fluid".
                </font>
              </a>
              <font color="008080"> J. Chem. Phys. 139, 174706(2013) </font>
            </li> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MachineLearning;
